export default __webpack_public_path__ + "static/media/miamiDolphinsVideo-2x.02790a26.jpg";